import {useEffect, useState} from 'react';
import {ImageSizeType} from '../types/images-layer';

const useImagesUpdateWidth = (
  stageRef: React.MutableRefObject<HTMLDivElement | null>
) => {
  const [stageSize, setStageSize] = useState<ImageSizeType>({
    width: 0,
    height: 0
  });

  const updateWidth = () => {
    if (stageRef.current) {
      const newWidth = stageRef.current.offsetWidth;
      setStageSize({width: newWidth, height: window.innerHeight});
    }
  };

  useEffect(() => {
    const resizeObserver = new ResizeObserver(updateWidth);

    if (stageRef.current) {
      resizeObserver.observe(stageRef.current);
    }

    const handleWindowResize = () => updateWidth();

    window.addEventListener('resize', handleWindowResize);

    updateWidth();

    return () => {
      if (stageRef.current) {
        resizeObserver.unobserve(stageRef.current);
      }

      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  return stageSize;
};

export default useImagesUpdateWidth;
